import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog as MUIDialog,
} from '@mui/material';
import React from 'react';
import useTracking, { TrackingEventData } from '../../../hooks/useTracking';
import { EventNames } from '../../../utils/trackingEvents';
import Button from '../Button';

interface DialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirmAction: () => void;
  cancelLabel?: string;
  cancelAction?: () => void;
  mixpanelData: TrackingEventData;
}

/**
 * Use this instead of a Snackbar when information is critical
 * and/or requires the user to take an action.
 */
export const Dialog: React.FC<DialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  confirmAction,
  cancelLabel,
  cancelAction,
  mixpanelData,
}) => {
  const { track } = useTracking();

  const onConfirm = () => {
    track(EventNames.DialogConfirmClick, mixpanelData);
    confirmAction();
  };
  const onCancel = () => {
    if (cancelAction) {
      track(EventNames.DialogCancelClick, mixpanelData);
      cancelAction();
    }
  };

  return (
    <MUIDialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* optional CANCEL */}
        {cancelLabel && cancelAction && (
          <Button onClick={onCancel} testId="cancel-button">
            {cancelLabel}
          </Button>
        )}
        {/* required CONFIRM */}
        <Button onClick={onConfirm} testId="confirm-button">
          {confirmLabel}
        </Button>
      </DialogActions>
    </MUIDialog>
  );
};
